import React from 'react';
import { useLocation } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

const Wrapper = styled.section`
  &.slide-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  &.slide-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  &.slide-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  &.slide-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }
  &.slide-enter-active,
  &.slide-exit-active {
    transition: opacity 200ms, transform 200ms;
  }
`

const Slide = ({ children }) => {
  const location = useLocation();
    
  return (
    <SwitchTransition>
      <CSSTransition
        key={location.pathname}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        classNames="slide"
      >
        <Wrapper>
          {children}
        </Wrapper>
      </CSSTransition>
    </SwitchTransition>
  );
}

export default Slide;
